import { Body, Controller, Post } from '@nestjs/common';
import { RevenueRegisterService } from './revenue-register.service';
import { CategoryWiseActAndBudgetForLastThreeYears, CountBySubCategoriesReq, CountBySubCategoryGroupReq, DateDevIdClientCodeIsTotalReq, DateReqForDashBoard, DrrDetailsResponse, revenueDetailsByCategoryReq, SubCategoryWiseActAndBudgetRevenueReq, SubCategoryWiseActAndBudgetRevenueResponse, SubCategoryWiseActRevenueResponse, TotalVOBandVOLYDetailsReq } from '@analytics-soa/shared-models';
import { DrrRequest } from './some.request';

@Controller('revenue-register')
export class RevenueRegisterController {
    constructor(
        private service: RevenueRegisterService
    ) {

    }

    @Post('/getDrrReport')
    async getDrrReport(@Body() obj: DrrRequest): Promise<DrrDetailsResponse> {
        try {
            console.log(obj);
            return await this.service.getDrrReport(obj);
        } catch (error) {
            return error
        }
    }

    @Post('/categoryId')
    async getIdForCategoryName(@Body() cat: any) {
        return await this.service.getIdForCategoryName(cat)
    }

    @Post('/subCategoryId')
    async getIdForSubCategoryName(@Body() subCat: any) {
        return await this.service.getIdForSubCategoryName(subCat)
    }

    @Post('getSubCategoryWiseActBudRevenueTotals')
    async getSubCategoryWiseActBudRevenueTotals(@Body() req: any) {
        return await this.service.getSubCategoryWiseActBudRevenueTotals(req)
    }

    @Post('getSubCategoryWiseActRevenue')
    async getSubCategoryWiseActRevenue(@Body() req: any): Promise<SubCategoryWiseActRevenueResponse> {
        try {
            return await this.service.getSubCategoryWiseActRevenue(req)
        } catch (error) {
            return error
        }
    }
    @Post('getSubCategoryWiseActAndBudgetRevenue')
    async getSubCategoryWiseActAndBudgetRevenue(@Body() req: any): Promise<SubCategoryWiseActAndBudgetRevenueResponse> {
        try {
            return await this.service.getSubCategoryWiseActAndBudgetRevenue(req)
        } catch (error) {
            return error
        }
    }

    @Post('getCategoryWiseActAndBudgetForLastThreeYears')
    async getCategoryWiseActAndBudgetForLastThreeYears(@Body() req: CategoryWiseActAndBudgetForLastThreeYears) {
        try {
            return await this.service.getCategoryWiseActAndBudgetForLastThreeYears(req)
        } catch (error) {
            return error
        }
    }
    @Post('getTotalVOBandVOLYDetails')
    async getTotalVOBandVOLYDetails(@Body() req: any) {
        try {
            return await this.service.getTotalVOBandVOLYDetails(req)
        } catch (error) {
            return error
        }
    }

    @Post('getRevenueDetailsByCategory')
    async getRevenueDetailsByCategory(@Body() req: any) {
        try {
            return await this.service.getRevenueDetailsByCategory(req)
        } catch (error) {
            return error
        }
    }

    @Post('getCountBySubCategoryGroup')
    async getCountBySubCategoryGroup(@Body() req: any) {
        try {
            return await this.service.getCountBySubCategoryGroup(req)
        } catch (error) {
            return error
        }
    }

    @Post('getCountBySubCategories')
    async getCountBySubCategories(@Body() req: any) {
        try {
            return await this.service.getCountBySubCategories(req)
        } catch (error) {
            return error
        }
    }

    @Post('getDateDetailsForReport')
    async getDateDetailsForReport(@Body() req: any) {
        try {
            return await this.service.getDateDetailsForReport(req)
        } catch (error) {
            return error
        }
    }

    @Post('/getAdminDrrReport')
    async getAdminDrrReport(@Body() reqObj: { date: string }): Promise<any> {
        try {
            return await this.service.getAdminDrrReport(reqObj);
        } catch (error) {
            return error
        }
    }

    @Post('getDivisionLevelCategoryDetails')
    async getDivisionLevelCategoryDetails(@Body() req: any) {
        try {
            return await this.service.getDivisionLevelCategoryDetails(req)
        } catch (error) {
            return error
        }
    }

    @Post('/getledgerReport')
    async getLedgerReport(@Body() obj: DrrRequest): Promise<any> {
        try {
            console.log(obj);
            return await this.service.getLedgerReport(obj);
        } catch (error) {
            return error
        }
    }
}

